import Vue from 'vue';
import Vuex from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {NumberFilter} from '@/shared/filter';
import {
	PaginatorActionWithFilters,
	PaginatorFilterState,
	PaginatorMutationFilter,
	StandardAction
} from '@/shared/utils';
import {Transporteur, Fournisseur} from '@/models';
import {TransporteurService} from '@/xhttp';
import store from '@/stores';

Vue.use(Vuex);

export class TransporteurFilter {

	Name: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';

	public clear(): void {
		this.Name = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
	}

	public toString(): string {
		return JSON.stringify({
			Name: this.Name,
			address : this.address,
			zipCode : this.zipCode,
			town : this.town,
		});
	}
}

class TransporteurState extends PaginatorFilterState<TransporteurFilter> {
	public transporteur: Transporteur = null;
	public transporteurs: ResultType<Transporteur> = null;
	public constructor() {
		super(new TransporteurFilter(), 'transporteurs', 'transporteur', 'listOrder', AscDesc.ASC, 50);
	}
}

class TransporteurStore {
	
	@XHTTPService(() => Transporteur)
	private transporteurService: TransporteurService;
	
	public state: TransporteurState = new TransporteurState();
	
	public mutations = {
		...PaginatorMutationFilter(() => storeTransporteur, 'transporteurs', 'transporteur'),
	};
	
	public actions = {
		...PaginatorActionWithFilters<Transporteur, TransporteurState>(() => Transporteur, 'transporteurs', 'transporteur'),
		...StandardAction<Transporteur, TransporteurState>(() => Transporteur, 'transporteur'),
	};
	
}
const instance = new TransporteurStore();
const storeTransporteur = new Vuex.Store(instance);
store.registerModule('transporteur', storeTransporteur);
export default storeTransporteur;
